// Exports
module.exports = {
	"root": "dh-forklaringsscroll-root"
};
